<template lang="html">
  <div>
    <p v-if="label != ''" class="pt-0 mb-0 small">
      {{ label }}
    </p>
    <b-form-radio-group
      id="btn-radios-2"
      v-model="_value"
      buttons
      button-variant="outline-secondary"
      size="sm"
      name="radio-btn-outline"
      class="max"
    >
      <template v-for="option in options">
        <b-form-radio :key="option.text" :value="option.value">
          <v-icon v-if="option.icon" :name="option.icon" />
          <span v-if="showText">{{ option.text }}</span>
        </b-form-radio>
      </template>
    </b-form-radio-group>
  </div>
</template>

<script>
export default {
  name: "TabButtons",
  props: {
    value: {
      type: String,
      default: () => ""
    },
    label: {
      type: String,
      default: () => ""
    },
    options: {
      type: Array,
      default: () => []
    },
    showText: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("changed", value);
      }
    }
  }
};
</script>

<style lang="css" scoped>
.max {
  width: 100% !important;
}
</style>
